import React from 'react';
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingSpinner } from '@/shared/components/ui/loading-spinner';

const LoadingContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}));

/**
 * A component that displays a loading indicator during authentication
 * This prevents the login page flash when a user is already authenticated
 */
export const AuthLoading: React.FC = () => {
  return (
    <LoadingContainer maxWidth={false}>
      {/* Usando o componente LoadingSpinner centralizado */}
      <LoadingSpinner size="lg" />
    </LoadingContainer>
  );
};

export default AuthLoading;
